import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { MissingFieldsComponent } from './components';

@NgModule({
  declarations: [MissingFieldsComponent],
  imports: [CommonModule, CustomModalModule, TranslateModule],
  exports: [MissingFieldsComponent],
})
export class MissingFieldsModule {}
